const globalToastState = {
  initial: "visible",
  states: {
    visible: {
      after: {
        2000: "hidden"
      }
    },
    hidden: {}
  }
}

export default {
  id: "luckydraw",
  initial: "idle",
  states: {
    idle: {},
    // showPrizeList: {
    //   initial: "pending",
    //   states: {
    //     pending: {
    //       invoke: {
    //         id: "getPrizeList",
    //         src: "getPrizeList",
    //         onDone: {
    //           target: "success",
    //           actions: ["setPrizeList"]
    //         },
    //         onError: {
    //           target: "failure"
    //         }
    //       }
    //     },
    //     success: {
    //       entry: "getAwardListReport"
    //     },
    //     failure: {
    //       entry: "luckyDrawErrorReport",
    //       meta: {
    //         ErrorMessage: "系统繁忙，请稍后再试！"
    //       }
    //     }
    //   }
    // },
    showDrawDialog: {
      initial: "beginning",
      states: {
        first: {
          initial: "success",
          states: {
            pending: {
              invoke: {
                id: "getPrizeList",
                src: "getPrizeList",
                onDone: {
                  target: "success",
                  actions: ["setPrizeList"]
                },
                onError: {
                  target: "failure"
                }
              }
            },
            success: {
              entry: ["sendStartDraw"]
            },
            failure: {
              entry: ["luckyDrawErrorReport", "sendStartDraw"],
              meta: {
                ErrorMessage: "系统繁忙，请稍后再试！"
              }
            }
          }
        },
        beginning: {
          initial: "pending",
          states: {
            pending: {
              invoke: {
                id: "getPrizeList",
                src: "getPrizeList",
                onDone: {
                  target: "success",
                  actions: ["setPrizeList"]
                },
                onError: {
                  target: "failure"
                }
              }
            },
            success: {
              entry: "getAwardListReport",
              on: {
                QUERY_AWARD: { target: "#luckydraw.showDrawDialog.queryAward", actions: "resetAwardListPage" }
              }
            },
            failure: {
              entry: ["luckyDrawErrorReport", "delPrizeList"],
              on: {
                QUERY_AWARD: { target: "#luckydraw.showDrawDialog.queryAward", actions: "resetAwardListPage" }
              },
              meta: {
                ErrorMessage: "系统繁忙，请稍后再试！"
              }
            }
          }
        },
        queryAward: {
          initial: "pending",
          states: {
            pending: {
              invoke: {
                id: "getLuckAward",
                src: "getLuckAward",
                onDone: {
                  target: "success",
                  actions: ["setWinAward"]
                },
                onError: {
                  target: "failure"
                }
              }
            },
            success: {
              entry: "getAwardReport",
              on: {
                CLOSE_AWARD_LIST: {
                  target: "#luckydraw.showDrawDialog.beginning"
                }
              }
            },
            failure: {
              entry: "luckyDrawErrorReport",
              meta: {
                ErrorMessage: "系统繁忙，请稍后再试！"
              }
            }
          }
        },
        receiveTaskPresent: {
          initial: "pending",
          states: {
            pending: {
              invoke: {
                id: "getTaskPresent",
                src: "getTaskPresent",
                onDone: {
                  target: "success",
                  actions: ["updatePresentRank"]
                },
                onError: {
                  target: "failure"
                }
              }
            },
            success: {
              always: "#luckydraw.showDrawDialog.getDrawCoupon"
            },
            failure: {
              entry: "luckyDrawErrorReport",
              initial: "visible",
              states: {
                visible: {
                  after: {
                    2000: "hidden"
                  }
                },
                hidden: {
                  always: "#appActivity.participate"
                }
              },
              meta: {
                message: "系统繁忙开宝箱失败，请重试"
              },
              on: {
                QUERY_AWARD: { target: "#luckydraw.showDrawDialog.queryAward", actions: "resetAwardListPage" }
              }
            }
          }
        },
        getDrawCoupon: {
          initial: "pending",
          states: {
            pending: {
              invoke: {
                id: "getLuckCoupon",
                src: "getLuckCoupon",
                onDone: [
                  {
                    target: "#luckydraw.showDrawDialog.drawPresent",
                    actions: ["setCouponNum"],
                    cond: "hasDrawCoupons"
                  },
                  {
                    actions: ["sendPrizeList"]
                  }
                  // {
                  //   target: "#luckydraw.showDrawDialog.notReachScore",
                  //   cond: "notReachScore"
                  // },
                  // {
                  //   target: "#luckydraw.showDrawDialog.notReachFinalAward",
                  //   cond: "notReachFinalAward"
                  // },
                  // {
                  //   target: "#luckydraw.showDrawDialog.hasNoCoupon"
                  // }
                ],
                onError: {
                  target: "failure"
                }
              }
            },
            failure: {
              initial: "visible",
              entry: "luckyDrawErrorReport",
              states: {
                visible: {
                  after: {
                    2000: "hidden"
                  }
                },
                hidden: {
                  always: "#appActivity.participate"
                }
              },
              meta: {
                message: "系统繁忙开宝箱失败，请重试"
              },
              on: {
                QUERY_AWARD: { target: "#luckydraw.showDrawDialog.queryAward", actions: "resetAwardListPage" }
              }
            }
          }
        },
        hasNoCoupon: {
          ...globalToastState,
          meta: {
            ErrorMessage: "请关闭弹窗，点击页面下方按钮购买解锁机会"
          },
          on: {
            QUERY_AWARD: { target: "#luckydraw.showDrawDialog.queryAward", actions: "resetAwardListPage" }
          }
        },
        notReachScore: {
          ...globalToastState,
          meta: {
            ErrorMessage: "购买步数开宝箱~"
          },
          on: {
            QUERY_AWARD: { target: "#luckydraw.showDrawDialog.queryAward", actions: "resetAwardListPage" }
          }
        },
        notReachFinalAward: {
          ...globalToastState,
          meta: {
            ErrorMessage: "解锁第6个宝箱自动赠送，当前暂无机会"
          },
          on: {
            QUERY_AWARD: { target: "#luckydraw.showDrawDialog.queryAward", actions: "resetAwardListPage" }
          }
        },
        drawPresent: {
          initial: "pending",
          states: {
            pending: {
              entry: "forwardStartDraw",
              invoke: {
                id: "startDraw",
                src: "startDraw",
                onDone: [
                  // {
                  //   target: "sixBoxDrawSuccess",
                  //   actions: "setDrawAward",
                  //   cond: "isSixthBoxDrawSuccess"
                  // },
                  {
                    target: "success",
                    actions: ["setDrawAward", "consumeUnusedCoupon"]
                  }
                ],
                onError: {
                  target: "failure"
                }
              }
            },
            success: {
              entry: "luckyDrawSuccessReport",
              on: {
                QUERY_AWARD: { target: "#luckydraw.showDrawDialog.queryAward", actions: "resetAwardListPage" }
              }
            },
            sixBoxDrawSuccess: {
              entry: "luckyDrawSuccessReport",
              ...globalToastState,
              meta: {
                message: "终极大奖已解锁，新的一圈已开始~"
              },
              on: {
                QUERY_AWARD: { target: "#luckydraw.showDrawDialog.queryAward", actions: "resetAwardListPage" }
              }
            },
            failure: {
              entry: "luckyDrawErrorReport",
              initial: "visible",
              states: {
                visible: {
                  after: {
                    2000: "hidden"
                  }
                },
                hidden: {
                  always: "#appActivity.participate"
                }
              },
              meta: {
                message: "自动开启宝箱失败，请手动开箱~"
              },
              on: {
                QUERY_AWARD: { target: "#luckydraw.showDrawDialog.queryAward", actions: "resetAwardListPage" }
              }
            }
          }
        }
      },
      on: {
        OPEN_BOX: [
          {
            cond: context => {
              const score = context.taskInfo.total_score
              const rank = context.selectedPresentRank
              return score < rank && score < 6
            },
            actions: "sendPrizeList"
          },
          {
            target: ".receiveTaskPresent",
            cond: context => {
              return context.availableReceivedRank.length > 0
            }
          },
          {
            target: ".getDrawCoupon"
          }
        ],
        QUERY_AWARD_PAGING: ".queryAward"
      }
    },
    showAward: {},
    batchDraw: {
      initial: "autoOpenBoxToast",
      states: {
        autoOpenBoxToast: {
          initial: "visible",
          states: {
            visible: {
              after: {
                2000: "hidden"
              },
              meta: {
                message: "宝箱即将自动开启……"
              }
            },
            hidden: {
              always: "#luckydraw.batchDraw.getAllTaskPresent"
            }
          }
        },
        getAllTaskPresent: {
          initial: "pending",
          states: {
            pending: {
              invoke: {
                id: "getAllTaskPresent",
                src: "getAllTaskPresent",
                onDone: {
                  target: "success",
                  actions: ["updateBatchPresentRank"]
                },
                onError: {
                  target: "failure"
                }
              }
            },
            success: {
              always: "#luckydraw.batchDraw.getAllLuckCoupon"
            },
            failure: {
              entry: ["getAllTaskPresentErrorReport"],
              always: "#luckydraw.batchDraw.receiveTaskOrGetCouponError"
              // initial: "visible",
              // states: {
              //   visible: {
              //     after: {
              //       2000: "hidden"
              //     },
              //     meta: {
              //       message: "自动开启宝箱失败，请手动开箱~"
              //     }
              //   },
              //   hidden: {
              //     always: "#appActivity.participate"
              //   }
              // }
            }
          }
        },
        getAllLuckCoupon: {
          initial: "pending",
          states: {
            pending: {
              invoke: {
                id: "getAllLuckCoupon",
                src: "getAllLuckCoupon",
                onDone: [
                  {
                    cond: "isBatchDrawActorExist",
                    target: "#luckydraw.batchDraw.startBatchDraw",
                    actions: ["updateUltimateUnusedCoupon", "reDrawActor"]
                  },
                  {
                    target: "#luckydraw.batchDraw.startBatchDraw",
                    actions: ["updateUltimateUnusedCoupon", "batchDrawActor"]
                  }
                ],
                onError: {
                  target: "failure"
                }
              }
            },
            failure: {
              entry: ["get6BatchCouponErrorReport"],
              always: "#luckydraw.batchDraw.receiveTaskOrGetCouponError"
              // initial: "visible",
              // states: {
              //   visible: {
              //     after: {
              //       2000: "hidden"
              //     },
              //     meta: {
              //       message: "自动开启宝箱失败，请手动开箱~"
              //     }
              //   },
              //   hidden: {
              //     always: "#appActivity.participate"
              //   }
              // }
            }
          }
        },
        receiveTaskOrGetCouponError: {
          initial: "pending",
          states: {
            pending: {
              invoke: {
                src: "checkAllLuckCoupon",
                onDone: [
                  {
                    target: "success",
                    actions: ["setUnusedCoupon"]
                  }
                ],
                onError: "failure"
              }
            },
            success: {
              entry: ["queryMultiCouponSuccessReport"]
            },
            failure: {
              entry: ["queryMultiCouponErrorReport"]
            }
          },
          meta: {
            message: "自动开启宝箱失败，请手动开箱~",
            btnText: "去开宝箱"
          },
          on: {
            CLOSE: "#appActivity.participate"
          }
        },
        startBatchDraw: {
          initial: "pending",
          states: {
            pending: {},
            success: {},
            failure: {
              ...globalToastState
            },
            couponInvale: {
              ...globalToastState
            }
          },
          on: {
            CLICK_PRESENT: [
              {
                target: "#luckydraw.showDrawDialog.first",
                actions: ["setSelectedPresentRank", "setAvailableOpenPresentRank", "clickPresentReport", "resetCouponNum"]
              }
            ],
            CLOSE: "#appActivity.participate",
            DRAW_ERROR: [
              {
                cond: "couponInvalid",
                target: ".couponInvale",
                actions: ["luckyDrawErrorReport"]
              },
              {
                cond: "hasBatchDrawError",
                target: ".failure",
                actions: ["luckyDrawErrorReport"]
              },
              {
                actions: ["recordBatchDrawError", "luckyDrawErrorReport"]
              }
            ],
            DRAW_SUCCESS: [
              {
                actions: ["luckyDrawSuccessReport"]
              }
            ],
            PLACE_ORDER: [
              {
                target: "#appActivity.participate.pay.forbidden",
                actions: ["buyProductReport"],
                cond: "forbiddenBuy"
              },
              {
                actions: ["savePurchaseInfo", "buyProductReport"],
                target: "#appActivity.participate.pay.preCheck"
              }
            ]
          }
        }
      }
    }
  },
  on: {
    CLOSE_PRESENT: "#appActivity.participate",
    CLOSE_DRAW_DIALOG: "#appActivity.participate",
    CLOSE_PRIZE_LIST_PREVIEW: "#appActivity.participate",
    CLOSE_DRAW_ERROR: "#appActivity.participate"
  }
}
